import React from 'react';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import ControlledMinMaxNumberInputs from './ControlledMinMaxNumberInputs';

const parse = (value) => {
  const result = parseFloat(value);
  return isNaN(result) ? null : result;
};

export default function ControlledMinMaxHours({
  classes = ControlledMinMaxNumberInputs.defaultProps.classes,
  disabled = false,
  label = translate('CONSTITUENT_TOTAL_TIME_CONTRIBUTED'),
  maxName = '',
  minName = '',
}) {
  const suffix = React.useCallback((value) => {
    return translate(
      value === '1'
        ? 'FORMS_HOURS_SINGULAR_SUFFIX'
        : 'FORMS_HOURS_PLURAL_SUFFIX',
    );
  }, []);

  return (
    <ControlledMinMaxNumberInputs
      classes={classes}
      disabled={disabled}
      id="hours"
      label={label}
      name="hours"
      maxName={maxName}
      minName={minName}
      parse={parse}
      suffix={suffix}
      thousandSeparator
      validationError={translate('FORMS_VALIDATION_MIN_TIME_INVALID')}
    />
  );
}

ControlledMinMaxHours.propTypes = {
  classes: ControlledMinMaxNumberInputs.propTypes.classes,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  maxName: PropTypes.string,
  minName: PropTypes.string,
};
